import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AiService } from '../../service/ai.service';
import { SnackService } from '../../service/snack.service';
import { Suggestion } from '../../interfaces/ai';
import { ReportService } from '../../service/report.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rr-ai-control',
  standalone: false,
  templateUrl: './ai-control.component.html',
  styleUrl: './ai-control.component.scss'
})
export class AiControlComponent implements OnInit, OnChanges {
  private controlSub?: Subscription;

  @Input() text1: string = ""
  @Input() text2: string = ""
  @Input() text3: string = ""
  @Input() placeholder: string = ""
  @Input() roundId: string = ""
  @Input() control: FormControl = new FormControl()
  @Input() necessaryWords: number = 0;
  @Input() streamId: string | null = null;
  @Input() stepId: string | null = null;
  @Input() communicationHistory: any;
  @Input() startClosingPrompt: boolean = false;
  @Input() autoFillDisabled: boolean = false;
  @Input() nextDisabled: boolean = false;

  @Input() promptType: string = "INITIALIZE_STEP_PROMPT";
  @Input() stepPromptNumber: number = 0;
  @Input() closingPromptNumber: number = 0;
  @Input() communicationHistoryType: string = "";

  maxRows: number = 30;
  row: number = 1
  charCount: number = 0;
  textareaValue: string = ""
  totalDiabledStatus: boolean = true;
  showAgentRow: boolean = false;
  showAgentSuggestions: boolean = false;
  twoWordsEmittet: boolean = false;
  aiIsRunning: boolean = false;

  @ViewChild('textarea') textarea!: ElementRef<HTMLTextAreaElement>;
  @Output() next: EventEmitter<any> = new EventEmitter<any>();
  @Output() autofill: EventEmitter<any> = new EventEmitter<any>();
  @Output() supportme: EventEmitter<any> = new EventEmitter<any>();
  @Output() stop: EventEmitter<any> = new EventEmitter<any>();
  @Output() moreThanTwoWords: EventEmitter<any> = new EventEmitter<any>();


  @Input() suggestions: Suggestion[] | any[] = [];
  controlMemory: Suggestion[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private aiService: AiService,
    private snack: SnackService,
    private report: ReportService
  ) {
    this.control.valueChanges.subscribe((value) => {
      this.checkINputValidation();
      this.calcHeithOfInput();
    });
    // ToDo: if step hast Initial Prompt run here

    // else set Type to 'STEP_PROMPT'
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['control']) {
      if (this.controlSub) {
        this.controlSub.unsubscribe();
      }
      this.controlSub = this.control.valueChanges.subscribe((value) => {
        this.checkINputValidation();
        this.calcHeithOfInput();
      });
    }
  }
  ngOnInit() {
    if (!this.controlSub) {
      this.controlSub = this.control.valueChanges.subscribe((value) => {
        this.checkINputValidation();
        this.calcHeithOfInput();
      });
    }
    this.checkINputValidation();
    this.cdr.detectChanges();
    this.calcHeithOfInput();
  }
  ngOnDestroy() {
    if (this.controlSub) {
      this.controlSub.unsubscribe();
    }
  }
  stopAiQuery() {
    this.aiIsRunning = false;
    this.showAgentRow = false;
    this.showAgentSuggestions = false;
    this.suggestions = [];
    this.stop.emit();
  }
  emitIfMoreThanTwoWord() {
    if (this.twoWordsEmittet === false) {
      this.twoWordsEmittet = true;
      this.moreThanTwoWords.emit(this.control.value);
    }
  }
  async startAiQuery() {
    // if suggestions are in Memory take the last 3 on because the first 3 oone are stcked by the first Call
    if (this.suggestions.length > 0 && this.controlMemory.length > 0) {
      this.suggestions = this.controlMemory.slice(3, 6);
      this.controlMemory = [];
      return;
    }

    // console.log('AI is running');
    if (!this.streamId || !this.stepId) {
      this.snack.error({ error: { msg: { "headline": "Frontend Error", "text": "Stream ID or Step ID is not provided" } } });
      console.error('Stream ID or Step ID is not provided');
      return;
    }
    this.promptType = 'STEP_PROMPT';
    this.aiIsRunning = true;
    this.showAgentRow = true;
    this.showAgentSuggestions = true;

    this.suggestions = [];
    let userInput = this.communicationHistoryType + this.control.value;

    if (this.communicationHistory?.length > 0) {
      for await (const history of this.communicationHistory) {
        userInput += `\n\n<${history.type}> ${history.content}`;
      }
    }
    this.report.saveReport(this.roundId, 'AI Button')
    let result = await this.aiService.getAiResponse(this.streamId, this.stepId, userInput, this.promptType, this.stepPromptNumber, this.roundId)
    if (result === false) {
      this.aiIsRunning = false;
      this.showAgentRow = false;
      this.showAgentSuggestions = false;
      return;
    }

    this.controlMemory = result.promptResult
    // only the first 3 elements of the Array
    this.suggestions = result.promptResult.slice(0, 3);

    this.aiIsRunning = false;
    this.showAgentRow = false;
    // this.showAgentSuggestions = false;
    this.calcHeithOfInput();
  }
  async autoFillAll() {
    if (!this.streamId || !this.stepId) {
      this.snack.error({ error: { msg: { "headline": "Frontend Error", "text": "Stream ID or Step ID is not provided" } } });
      console.error('Stream ID or Step ID is not provided');
      return;
    }
    this.promptType = 'FILL_OUT_ALL_PROMPT';
    this.stepPromptNumber = 0;
    this.aiIsRunning = true;
    this.showAgentRow = false;
    this.showAgentSuggestions = false;
    this.suggestions = [];
    let result = await this.aiService.getAiResponse(this.streamId, this.stepId, this.control.value, this.promptType, this.stepPromptNumber, this.roundId);
    if (result === false) {
      this.aiIsRunning = false;
      this.showAgentRow = false;
      this.showAgentSuggestions = false;
      return;
    }
    this.report.saveReport(this.roundId, 'Autofill All')
    this.autofill.emit(result);
    this.calcHeithOfInput();
  }

  checkINputValidation() {
    if (typeof this.control.value !== 'string') {
      let inputValue = this.control.value;
      this.control.setValue(inputValue.toString());
    }
    let findWords = this.control.value?.split(' ').length;
    let lastWord = this.control.value?.split(' ').pop();

    if (findWords > 2) {
      this.emitIfMoreThanTwoWord();
    } else {
      // ToDo: Check by Jan if correct?
      this.twoWordsEmittet = false;
    }
    // console.log("Words..", findWords > this.necessaryWords || (findWords === this.necessaryWords && lastWord.length > 0));

    if (findWords > this.necessaryWords || (findWords === this.necessaryWords && lastWord.length > 0)) {
      this.totalDiabledStatus = false;
      this.autoFillDisabled = false;
      this.nextDisabled = false;
    } else {
      this.totalDiabledStatus = true;
      this.nextDisabled = true;
      // this.autoFillDisabled = true;
    }
    if (this.control.value == "" || this.control.value === undefined) {
      this.nextDisabled = true;
    }

  }
  addSuggestionToTextarea(suggestion: Suggestion) {
    if (suggestion.text) this.control.setValue(suggestion.text);
    else this.control.setValue(suggestion);
    this.showAgentSuggestions = false;
    this.totalDiabledStatus = false;
    this.calcHeithOfInput();
  }

  onInput(event: Event) {
    this.calcHeithOfInput();
  }
  calcHeithOfInput() {

    const textarea = this.textarea.nativeElement;
    const style = window.getComputedStyle(textarea);
    const lineHeight = parseInt(style.lineHeight, 10);
    const paddingTop = parseInt(style.paddingTop, 10);
    const paddingBottom = parseInt(style.paddingBottom, 10);
    const totalPadding = paddingTop + paddingBottom;
    const lines = Math.floor((textarea.scrollHeight - totalPadding) / lineHeight);

    if (lines > this.maxRows) {
      this.charCount = textarea.value.length;
      const trimmedValue = textarea.value.slice(0, this.charCount - 1);
      textarea.value = trimmedValue;
      this.control.setValue(trimmedValue);
      return;
    }
    this.row = lines;
    // console.log('Check heigth', this.row);
    this.checkINputValidation();

  }
}
